import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function FooterSection() {
  return (
    <footer className="bg-secondary-100/60 border-t border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg text-foreground-950 mb-4">Sugargoo Sheet</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The ultimate Sugargoo Spreadsheet resource hub — helping shoppers discover, compare and research products faster.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  Home
                </a>
              </li>
              <li>
                <a href="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  Complete Guide
                </a>
              </li>
              <li>
                <a href="/#guides" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  Shopping Guide
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  Main Website
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              {articles.map((article) => (
                <li key={article.slug}>
                  <a href={`/${article.slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                    {article.title.length > 40 ? article.title.substring(0, 40) + '...' : article.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved. Independent research platform.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              Main Website
            </a>
            <a href="/sugargoo-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              Complete Guide
            </a>
            <a href="/#guides" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              All Guides
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}